import { render } from "./SitePromos.vue?vue&type=template&id=0b93a41a"
import script from "./SitePromos.vue?vue&type=script&setup=true&lang=js"
export * from "./SitePromos.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SitePromos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b93a41a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b93a41a', __exports__)) {
    api.reload('0b93a41a', __exports__)
  }
  
  module.hot.accept("./SitePromos.vue?vue&type=template&id=0b93a41a", () => {
    api.rerender('0b93a41a', render)
  })

}


export default __exports__